import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, OnInit } from '@angular/core';
import { environment } from '@env/environment';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ResetPasswordService implements OnInit {
  api_url = environment.baseIP + environment.apiPrefix;
  access_token: any;
  file = []
  constructor(
    private httpClient: HttpClient,
    private _cookieService: CookieService,
  ) {
    this.access_token = this._cookieService.get("access_token");
  }

  ngOnInit(): void {

  }
  //start note 
  userResetPassword(formData:any): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + this.access_token
    });

    return this.httpClient.post(
      `${this.api_url}user/reset-password`,
      formData,
      { headers: headers }
    );
  }


  //end note


}